import { DashboardState } from './partials/dashboard'
import { DocketEntryEditState } from './partials/docket-entry-edit'
import { PrintState } from './partials/print'
import { UploadLinksState } from './partials/upload-links'

export const DocketEntryState = _ => ({
  ...DashboardState,
  ...DocketEntryEditState,
  ...PrintState,
  ...UploadLinksState,

  docketEntry: {},
  docketEntryType: {},
})
